export const generateGmapsURL = (values: any): string => {
  const returnValues = values

  let address = ''

  address += returnValues?.street || ''
  // address += Number.isNaN(Number(values?.number))
  //   ? ',' + returnValues?.number
  //   : ''
  address += Number(values?.number) ? ', ' + returnValues?.number : ''
  address += returnValues?.district ? '-' + returnValues?.district : ''
  address += returnValues?.city ? ', ' + returnValues?.city : ''
  address += returnValues?.state ? ' - ' + returnValues?.state : ''
  address += returnValues?.zipCode ? ', ' + returnValues?.zipCode : ''

  return address
}
